/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getFieldZoneLayout } from "cms/fields/field-utils";
import { RichTextFieldDisplay } from "./display";
import { RichTextFieldEdit } from "./edit";

const RichTextField = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <RichTextFieldDisplay />,
        editComponent: <RichTextFieldEdit />,
    };
    return getFieldZoneLayout(zoneProps);
};
RichTextField.displayName = "RichTextField";
export { RichTextField };
